import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import type {
	GetWidgetInteractionRequestParams,
	GetWidgetInteractionResponse,
} from './types';

export const getWidgetInteraction = async ({
	widgetId,
	isApp = false,
	lang,
	interactionsBaseUrl,
}: GetWidgetInteractionRequestParams): Promise<
	AxiosResponse<GetWidgetInteractionResponse>
> => {
	const url = interactionsBaseUrl
		? `${interactionsBaseUrl}/${widgetId}`
		: `/cityzens/interactions/${widgetId}`;

	const params: Record<string, string | boolean> = {
		isApp: Boolean(isApp),
	};
	if (lang) {
		params.lang = lang;
	}

	return api.get<GetWidgetInteractionResponse>(url, { params });
};
